import { getSubdomainData } from '@apparel/apparel/src/lib/utils';
import GameBreaker from '@apparel/core/arts/logo/gamebreaker_black.png';

interface SimpleLogoProps {
    height?: number;
    alt?: string;
}

export function SimpleLogo({ alt, ...rest }: SimpleLogoProps) {
    const subdomainData = getSubdomainData();
    if (subdomainData?.logo) {
        return <img src={subdomainData?.logo} alt={alt || subdomainData?.company_name} {...rest} />;
    }

    return <img src={GameBreaker} alt={alt || 'Gamebreaker'} {...rest} />;
}

export default SimpleLogo;
